import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [vehicle, setVehicle] = useState("");
  const [prefill, setPrefill] = useState(null);
  const [reservationToken, setReservationToken] = useState("");

  // Public "Book Now" actions now route to the pre-screening request form
  const openBooking = (preselected = "") => {
    window.location.assign(`/request${preselected ? `?vehicle=${encodeURIComponent(preselected)}` : ""}`);
  };

  // Approved customers with a private link get the full booking flow
  const openApproved = (data, token) => {
    setPrefill(data || null);
    setReservationToken(token || "");
    setVehicle(data?.vehicle || "");
    setOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, vehicle, openBooking, openApproved, prefill, reservationToken }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
};
